const userModule = angular.module('user', []);

const userService = require('./user.service');
userModule.factory('User', userService);

module.exports = userModule;